import styled from 'styled-components';

export default function TaxExemptCheckbox({ checked, disabled, label, onChange }: {
  checked: boolean; disabled?: boolean; label: string; onChange: (checked: boolean) => void;
}) {
  return <Label><input type="checkbox" aria-label={label} checked={checked} disabled={disabled}
    onChange={event => onChange(event.target.checked)} />면세</Label>;
}

const Label = styled.label`
  && { display: inline-flex; align-items: center; gap: var(--space-2); min-height: var(--control-lg); width: fit-content;
    color: var(--color-text-primary); font-size: var(--text-body); cursor: pointer; }
  && input { flex: none; width: var(--space-5); height: var(--space-5); margin: 0; accent-color: var(--color-brand); cursor: pointer; }
  &:has(input:disabled) { color: var(--color-text-disabled); cursor: default; }
  && input:disabled { cursor: default; }
  input:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
`;
